/**
 * Raw remote feature flag keys, kept in a module with no other imports so they can be safely
 * referenced from contexts that shouldn't pull in the full feature flag system (e.g. Statsig, env
 * config) — such as Playwright e2e tests, which run under Node rather than a bundler.
 */
export const FEATURE_FLAG_KEYS = {
    enableTopLevelOrgCreateFlow: 'enable_top_level_org_create_flow',
    enableGCHome: 'gc_home',
} as const;
